export const BILLINGS_ONE_API_PREFIX = 'Billingsapi';
export const EXTERNAL_BILLINGS_URL = `${BILLINGS_ONE_API_PREFIX}/private/v1.0.0/externalbillingitems`;
